import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState } from '../../../../types/types';
import { chatCommentAddedRest } from './api/chatCommentAddedRest';
import { IComment } from '../../../../store/model/card/types/IComment';

//TODO done
/***
 * Сделами коментарий. теперь надо у всех кто подписан на чат,
 * обновить инфу от последнем коменте и счетчик не процитанных
 * @param comment
 */
export const chatCommentsAdd = (
    comment: IComment,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(chatCommentAddedRest(comment));
    };
    return action;
};
